import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { obtenerProductos } from "../redux/actions";

const ReporteStock = () => {
  const dispatch = useDispatch();
  const productos = useSelector((state) => state.productos);
  const [busqueda, setBusqueda] = useState("");
 
  

 // Filtrar los productos según la búsqueda
 const productosFiltrados = productos.filter((producto) => {
  const busquedaLower = busqueda.toLowerCase();
  return (
    producto.nombre.toLowerCase().includes(busquedaLower) ||
    producto.codigoBarras.includes(busquedaLower)
  );
});

// Ordenar los productos por stock y alfabéticamente
const productosOrdenados = [...productosFiltrados].sort((a, b) => {
  // Ordenar por stock en orden descendente
  if (b.stock !== a.stock) {
    return b.stock - a.stock;
  }
  // Si el stock es igual, ordenar alfabéticamente por nombre
  return a.nombre.localeCompare(b.nombre);
});

  useEffect(() => {
    dispatch(obtenerProductos());
  }, [dispatch]);

  return (
    <div className="p-4 bg-backgroundClaro min-h-screen h-full w-full">
      <div className="bg-backgroundOscuro rounded-lg p-4">
        <h1 className="flex text-textoClaro justify-center text-2xl font-semibold mb-4">
          Listado de Productos
        </h1>
        <div className="mb-4">
          <input
            type="text"
            className="bg-backgroundClaro border-[#000000] rounded-lg text-textoOscuro placeholder-[#808080] focus:ring-4 focus:ring-green-800 focus:border-green-600 w-[100%] p-2 sm:p-1"
            placeholder="Buscar por nombre o ID"
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
            aria-label="Buscar productos por nombre o ID"
          />
        </div>
        <div className="overflow-x-auto">
          <table className="caption-bottom text-sm w-full">
            <thead className="[&_tr]:border-b border-b-[1px] p-6 border-zinc-800">
              <tr className="dark:border-zinc-800">
                <th className="h-12 px-4 align-middle text-textoClaro font-medium text-muted-foreground cursor-pointer border-zinc-200 pl-5 pr-4 pt-2 text-start dark:border-zinc-800">
                  Nombre Producto
                </th>
                <th className="h-12 px-4 align-middle text-textoClaro font-medium text-muted-foreground cursor-pointer border-zinc-200 pl-5 pr-4 pt-2 text-start dark:border-zinc-800">
                  Categoría
                </th>
                <th className="h-12 px-4 align-middle text-textoClaro font-medium text-muted-foreground cursor-pointer border-zinc-200 pl-5 pr-4 pt-2 text-start dark:border-zinc-800">
                  Cantidad
                </th>
                <th className="h-12 px-4 align-middle text-textoClaro font-medium text-muted-foreground cursor-pointer border-zinc-200 pl-5 pr-4 pt-2 text-start dark:border-zinc-800">
                  Unidad
                </th>
              </tr>
            </thead>
            <tbody>
              {productosOrdenados.length > 0 ? (
                productosOrdenados.map((e) => (
                  <tr
                    key={e.id}
                    className="border-b transition-colors hover:bg-muted/50 dark:hover:bg-gray-900"
                  >
                    <td className="p-4 align-middle w-max border-b-[1px] text-textoClaro border-zinc-200 py-5 pl-5 pr-4 dark:border-white/10">
                      {e.nombre}
                    </td>
                    <td className="p-4 align-middle w-max border-b-[1px] text-textoClaro border-zinc-200 py-5 pl-5 pr-4 dark:border-white/10">
                      {e.categoria?.nombre || "Sin categoría"}
                    </td>
                    <td className="p-4 align-middle w-max border-b-[1px] text-textoClaro border-zinc-200 py-5 pl-5 pr-4 dark:border-white/10">
                      {e.stock}
                    </td>
                    <td className="p-4 align-middle w-max border-b-[1px] text-textoClaro border-zinc-200 py-5 pl-5 pr-4 dark:border-white/10">
                      {e.unidadMedida}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    className="border-b text-center text-textoClaro p-4"
                    colSpan="3"
                  >
                    No hay productos disponibles
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ReporteStock;
